var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wifi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M17.1633 3.24522C19.2795 5.76675 20.4395 8.95335 20.4395 12.2452C20.4395 15.5371 19.2795 18.7237 17.1633 21.2452",
    stroke: "white",
    strokeWidth: 1.4371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_2",
    d: "M14.1028 18.6952C15.6256 16.891 16.4609 14.6062 16.4609 12.2452C16.4609 9.88426 15.6256 7.59944 14.1028 5.79523",
    stroke: "white",
    strokeWidth: 1.4371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_3",
    d: "M11.0538 16.1152C11.9675 15.0327 12.4687 13.6618 12.4688 12.2452C12.4687 10.8286 11.9675 9.45775 11.0538 8.37523",
    stroke: "white",
    strokeWidth: 1.4371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.c219434bebe04acf1f33cb9265a7dd2d.svg";
export { ForwardRef as ReactComponent };